import React from "react";

import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useState } from "react";
import { useVerifyAccessToken } from "../Hooks/auth.hook";

const Protected = ({ Component }) => {
  const navigate = useNavigate();

  const { data, status, remove } = useVerifyAccessToken();
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    if (status == "success" && data.status == 200) {
      setIsAuthenticated(true);
    } else if (
      status == "success" &&
      (data.status == 401 || data.status == 403)
    ) {
      navigate("/signin");
    }
  }, [status]);

  useEffect(() => {
    return () => {
      remove();
    };
  }, []);

  return (
    <div>
      {isAuthenticated !== null && isAuthenticated == true ? (
        <Component />
      ) : (
        <h1>loading</h1>
      )}
    </div>
  );
};

export default Protected;
